import React, { useState } from 'react';
import { Modal, Box, Button } from '@mui/material';
import ReadMoreIcon from '@mui/icons-material/ReadMore';
import PropTypes from 'prop-types';

function HtmlRenderer({ htmlString, modalContent, showMoreButton = true }) {
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const highlightWords = ['error', 'warning', 'success', 'growth', 'growing', 'executive', 'summary'];

  const colorMap = {
    error: 'red',
    warning: 'orange',
    success: 'green',
    brand: '#B22234',
    growth: 'green',
    growing: 'green',
    executive: '#04265C',
    summary: '#B22234',
  };

  const getHighlightedHTML = (html) => {
    let highlighted = html;

    highlightWords.forEach((word) => {
      const regex = new RegExp(`\\b(${word})\\b`, 'gi');
      highlighted = highlighted.replace(
        regex,
        `<span style="color: ${colorMap[word.toLowerCase()]}; font-weight: bold;">$1</span>`
      );
    });

    const brandRegex = /\b(brand\w*)\b/gi;
    highlighted = highlighted.replace(
      brandRegex,
      `<span style="color: ${colorMap.brand}; font-weight: bold;">$1</span>`
    );

    return highlighted;
  };

  return (
    <>
      {/* Main HTML rendering */}
      <Box
        sx={{ paddingLeft: '30px' }}
        dangerouslySetInnerHTML={{ __html: getHighlightedHTML(htmlString) }}
      />

      {/* More button */}
      {showMoreButton && (
        <Button onClick={handleOpen}   
          variant="contained"
          startIcon={<ReadMoreIcon />}
          sx={{
            mt: 2,
            ml: '30px',
            textTransform: 'none',
            backgroundColor: '#fafbfc',
            color: '#00265E',
            fontWeight: 'bold',
            boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.2)',
            borderRadius: '8px',
            paddingX: 2,
            paddingY: 1,
            '&:hover': {
              color: '#ffffff',
              backgroundColor: '#001f4d',
              boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.3)',
            },
          }}
          >
          More
        </Button>
      )}

      {/* Modal */}
      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            bgcolor: 'background.paper',
            boxShadow: 24,
            borderRadius: 2,
            maxWidth: 1100,
            width: '100%',
            maxHeight: '80vh',
            overflow: 'auto',
            p: 4,
          }}
        >
          {/* Scrollable HTML content */}
          <Box
            sx={{
              overflowY: 'auto',
              '& ul': { marginBottom: 1 },
              '& ul > li': { marginBottom: 0.5 },
              '& ul ul': { marginTop: 0.25, marginBottom: 0.25 },
              '& ul ul li': { marginBottom: 0.25 },
            }}
            dangerouslySetInnerHTML={{ __html: getHighlightedHTML(modalContent) }}
          />

          <Box mt={3} textAlign="right">
            <Button onClick={handleClose} variant="contained"
            sx={{
              mt: 2,
              textTransform: 'none',
              backgroundColor: '#00265E',
              color: '#fafbfc',
              fontWeight: 'bold',
              boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.2)',
              borderRadius: '8px',
              paddingX: 2,
              paddingY: 1,
              '&:hover': {
                color: '#ffffff',
                backgroundColor: '#001433',
                boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.3)',
              },
            }}
            >
              Close
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
}

HtmlRenderer.propTypes = {
  htmlString: PropTypes.string.isRequired,
  modalContent: PropTypes.string.isRequired,
  showMoreButton: PropTypes.bool,
};

export default HtmlRenderer;
